import {StateUtils} from "@spartacus/core";
import {MULTI_CART_DATA} from "@spartacus/cart/base/core";

export const RESET_ACTIONS = 'Gonvarri Reset Actions';

export class GonvarriResetActions extends StateUtils.EntityProcessesIncrementAction {
  override readonly type = RESET_ACTIONS;
  constructor() {
    super(MULTI_CART_DATA, "");
  }
}
